module.exports = __webpack_public_path__ + "web/img/mvp-bg.d8f4aaef.png";